<template lang="pug">
  vm-prompt(:vm-buttons-hidden="true" vm-size="large" @vm-cancel="close" @vm-close="close" :vm-active="isModalVisible" :vm-title='getTitle')
    vm-row(class="section-invoice" vm-align="center" vm-type="flex" vm-justify="space-between" vm-w="12" v-shortcuts="[{ shortcut: [ 'enter', ], callback: savePayment, push: true, focus: true },]")
      vm-col(class="section-invoice__titles", vm-align="center", vm-w=4)
        h3 {{ $t('strings.invoice') }}: {{ supplierInvoice.invoice.invoice_number }}
      vm-col(class="section-invoice__titles", vm-align="center", vm-w=4)
        h3 {{ $t('strings.total_payment') }}: {{ supplierInvoice.invoice.total | currency}}
      vm-col(class="section-invoice__titles", vm-align="center", vm-w=4)
        h3 {{ $t('strings.total_remaining') }}: {{ supplierInvoice.invoice.total_payments_amount | currency}}
    vm-row(class="section-inputs" vm-align="center" vm-type="flex")
      vm-col(class="section-inputs__titles", vm-align="center", vm-w=3)
        b-form-group
          vm-input(type="currency" autofocus :placeholder='$t("supplier_invoices.amount_placeholder")' :danger="$v.form.total.$invalid && $v.form.total.$model" :danger-text="$t('validation.required', { attribute: $t('supplier_invoices.amount') })" v-model="form.total" :label='$t("supplier_invoices.total")')
      vm-col(class="section-inputs__titles", vm-align="center", vm-w=3)
        b-form-group
          vm-date-picker.filter(type="date" :label="$t('supplier_payments.payment_date')" :placeholder="$t('strings.select_date')" @on-change="handleChange" :danger="$v.form.payment_date.$invalid && $v.form.payment_date.$model" :danger-text="$t('validation.required', { attribute: $t('supplier_invoices.payment_date') })" v-model="form.payment_date")
      vm-col(class="section-inputs__titles", vm-align="center", vm-w=3)
        b-form-group
          vm-select(autocomplete :placeholder='$t("supplier_invoices.payment_type_placeholder")' :danger-text="$t('validation.required', { attribute: $t('supplier_invoices.status') })"  v-model="form.payment_type" :label='$t("supplier_invoices.payment_type")')
            vm-select-item(:key="index" :value="item.value" :text="item.text" v-for="(item,index) in types")
      vm-col(class="section-inputs__button", vm-align="center", vm-w=3)
        vm-button(:disabled="$v.form.$invalid" class="button_white" icon="copy-outline" @click="savePayment") {{ $t('supplier_payments.add') }}
    vm-row(class="section-tables" vm-align="center" vm-type="flex" vm-justify="space-between" vm-w="12")
      vm-col(vm-justify="center", vm-align="center", vm-w=12)
        vm-table(max-height="350px" max-items="10" pagination :data="supplierInvoice.invoice.payments" )
          template(slot="thead")
            vm-th(:key="index" v-for="(column, index) in columns") {{ $t('supplier_invoices.' + column) }}
          template(slot-scope="{data}")
            vm-tr(:data="tr" :key="indextr" v-for="(tr, indextr) in data")
              vm-td(:data="data[indextr][column]" :key="index" v-for="(column, index) in columns")
                slot(v-if="column == 'total' || column == 'amount'")  {{data[indextr][column] | currency }}
                slot(v-if="column == 'payment_date'")  {{data[indextr][column] | moment("DD MMMM YYYY") }}
                slot(v-if="column != 'status' && column != 'payment_date' && column != 'amount' && column != 'name' && column != 'role' && column != 'total' && column != 'unit_price'") {{data[indextr][column]}}
              vm-td
              vm-dropdown(vm-custom-content vm-trigger-click vm-trigger-outside-click)
                vm-button(type="flat" icon="more-horizotnal" color="#afbbc6")
                vm-dropdown-menu
                  vm-dropdown-item.d-flex.justify-content-between(@click="deletePaymentConfirm(data[indextr])")
                    vm-icon(icon="trash-2-outline")
                    slot &nbsp;{{ $t('strings.delete') }}

</template>

<script>
import ModalMixin1 from '@/mixins/ModalMixin1'
import { required, maxValue } from 'vuelidate/lib/validators' // Ver documentacion
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('SupplierPayments')

export default {
  name: 'ModalSupplierPayments',
  mixins: [ModalMixin1],
  data: () => ({
    columns: [
      'id',
      'subtotal',
      'tax_amount',
      'total',
      'payment_date',
      'payment_type',
      'user_display'
    ],
    types: [
      {
        text: 'Efectivo',
        value: 'cash'
      },
      {
        text: 'Tarjeta',
        value: 'card'
      },
      {
        text: 'Trasferencia',
        value: 'trasfer'
      }
    ]
  }),
  validations () {
    return {
      form: {
        total: {
          required,
          maxValue: maxValue(this.supplierInvoice.invoice.total_payments_amount)
        },
        payment_date: {
          required
        },
        payment_type: {
          required
        }
      }
    }
  },
  computed: {
    ...mapGetters(['isModalVisible', 'catalog', 'supplierInvoice'])
  },
  watch: {
    'form.total' (total) {
      this.form.tax_amount = total * this.supplierInvoice.invoice.tax_type
      this.form.subtotal = parseFloat(total) - +parseFloat(this.form.tax_amount)
    }
  },
  methods: {
    ...mapActions([
      'addPayment',
      'editRecord',
      'deletePayment',
      'setModalVisible',
      'loadCatalog',
      'setInvoiceModal'
    ]),
    savePayment () {
      this.addPayment({
        ...this.form,
        supplier_invoice_id: this.supplierInvoice.invoice.id
      }).then(() => {
        this.form = {}
      })
    },
    close () {
      this.setModalVisible(false)
    },
    async deletePaymentConfirm (record) {
      let t = this
      this.auxDeleteRecord = () => {
        t.deletePayment(record).then(() => {
          t.selected = []
        })
      }
      this.$vm.dialog({
        color: 'danger',
        title: this.$t('front.delete_modal'),
        text: this.$t('front.delete_confirmation2', {
          model: this.$t('strings.payment'),
          attribute: record.id
        }),
        accept: this.auxDeleteRecord
      })
    }
  }
}
</script>
<style lang="scss">
.section-invoice {
  padding: 10px;
}
.section-inputs {
  margin: 5px;
  .vm-datepicker {
    margin-left: 5px;
  }
  .vm-input {
    margin: 5px;
  }
  &__button {
    justify-content: center;
    display: flex;
  }
}
</style>
